import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { StarRow } from "@/components/StarRow";
import { AppRatingForm } from "@/components/AppRatingForm";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/categories";

export default function AppReviews() {
  const { user, refreshUser } = useAuth();
  const [params] = useSearchParams();
  const [summary, setSummary] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [writing, setWriting] = useState(params.get("rate") === "1");
  const load = () => {
    api.get("/app-reviews/summary").then((r) => setSummary(r.data)).catch(() => {});
    api.get("/app-reviews").then((r) => setReviews(r.data)).catch(() => {});
  };
  useEffect(load, []);

  return (
    <main data-testid="app-reviews-page" className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight">What travelers say</h1>
      {summary && (
        <p data-testid="app-reviews-summary" className="mt-4 flex items-center gap-3 text-lg">
          <StarRow value={summary.average} size="h-6 w-6" /> <b>{summary.count ? summary.average.toFixed(1) : "–"}</b>
          <span className="text-slate-400 text-sm">{summary.count} {summary.count === 1 ? "rating" : "ratings"}</span>
        </p>
      )}
      {user && (writing ? (
        <div className="mt-8 rounded-2xl bg-[#151C2C] border border-[#26334D] p-5 max-w-md">
          <AppRatingForm onDone={() => { setWriting(false); load(); refreshUser(); }} />
        </div>
      ) : (
        <button data-testid="app-reviews-write" onClick={() => setWriting(true)} className="mt-8 px-5 h-11 rounded-full bg-[#FF3B6B] text-white font-semibold hover:bg-[#E0335D] transition-colors">Rate VacaVibe</button>
      ))}
      <div className="mt-10 space-y-4">
        {reviews.length === 0 && <p className="text-slate-500">No written reviews yet.</p>}
        {reviews.map((r) => (
          <article key={r.id} data-testid={`app-review-${r.id}`} className="rounded-2xl bg-[#151C2C] border border-[#26334D] p-5">
            <div className="flex items-center justify-between"><span className="font-semibold">{r.name}</span><span className="text-xs text-slate-500">{fmtDate(r.created_at.slice(0, 10))}</span></div>
            <StarRow value={r.rating} />
            <p className="mt-2 text-slate-300 text-sm whitespace-pre-line">{r.text}</p>
          </article>
        ))}
      </div>
    </main>
  );
}
